import { mapGetters } from "vuex";
import { ReturnsService } from "@/services/ReturnsService"
import { stringHelper } from "@/components/mixins/stringHelper"

export const returnAddItems = {
    data: () => ({
      returnDraftItemDto: {
        OemPartCode: "",
        Quantity: null
      },
      partsToReturnColumns: [
        { key: "OemPartCode",       label: "Oem Part Code",      sortable: true },
        { key: "PartDescription",   label: "Part Description",   sortable: true },
        { key: "SalesOrganization", label: "Sales Organization", sortable: true },
        { key: "Quantity",          label: "Quantity",           sortable: true },
        { key: "Price",             label: "Price",              sortable: true },
        { key: "Total",             label: "Total",              sortable: true },
        { key: "DeleteRow",         label: "",                   sortable: false, class: "pt-2" }
      ],
      total: 0,
      availableTotal: 0,
      draftLoading: false
    }),

    mixins: [stringHelper],

    methods: {
      AddDraftItem(addWithError = false){
        this.draftLoading = true
          // We need to address errors when looking for the part. See the watch section I started above.
        ReturnsService.AddDraftItem(this.activeAccountId, this.user.UserId, this.returnDraftDto.Id, this.returnDraftItemDto).then(result => {
          let draftErrorCount = this.processDraftErrors(result.data);  
            if( addWithError || draftErrorCount === 0){
              this.updateDto(result.data)
            }
            this.calculateTotals();
            this.draftLoading = false
          }).catch(() => {
            this.draftLoading = false
          });
      },
      processDraftErrors(draftResult){
        let draftErrorCount = 0;
        // Draft item errors
        for( let itemIter = 0; itemIter < draftResult.Items.length; itemIter++){
          // Item not returnable
          let notReturnableError = draftResult.Items[itemIter].Errors.filter(function(error){
            return error == "ItemNotReturnable";
          })
          if( notReturnableError.length > 0){
              return 1;
          }
          // All item errors
          for( let errorIter = 0; errorIter < draftResult.Items[itemIter].Errors.length; errorIter++){
            let itemError = draftResult.Items[itemIter].Errors[errorIter];
            if(itemError === "LineItemMinimumAmount"){
              let amount = draftResult.MinimumItemAmount;
              let currency = draftResult.Items[0].Currency;
              let currencyAmount = this.formatToCurrency(amount, currency);
              itemError = this.format(this.getContentItem(itemError), currencyAmount);
              this.showDraftError(itemError, true);
            }else{
              this.showDraftError(itemError);
              draftErrorCount++;
            }  
          }
        }

        // Draft level errors
        if (draftResult.Errors.length > 0) {
          for (let i = 0; i < draftResult.Errors.length; i++) {      
            let draftError = draftResult.Errors[i];
            if(draftError === "ItemQuantityMissing"){
              draftError = this.getContentItem(draftError)
              this.showDraftError(draftError, true);
            }
            else if(draftError === "ReturnTotalMinimumAmount"){
              let amount = draftResult.MinimumReturnAmount;
              let currencyAmount = this.formatToCurrency(amount, draftResult.Items[0].Currency);
              draftError = this.format(this.getContentItem(draftError), currencyAmount);
              this.showDraftError(draftError, true)
            }else{
              this.showDraftError(draftError);
              //If the draftError count is greater than zero, the returnDraftDto will not be updated, which we want in some cases..
              //but in these two cases here, ("ExceedsMaAuthorizedAmount","ExceedsRpAuthorizedAmount")
              //we still want the items to be shown in the table for the items in the return to show the user the amounts for feedback
              if(!["ExceedsMaAuthorizedAmount","ExceedsRpAuthorizedAmount"].includes(draftError)){
                draftErrorCount++;
              }
            }
            
          }
        }
        return draftErrorCount;
      },
      showDraftError(errorMessage,isContentItem = false){

        let message = errorMessage
        if(isContentItem === false){
          message = this.getContentItem(errorMessage)
        }
        this.$store.commit("pushTimedMessage",{
          header: "Error adding return item",
          message: message,
          IsError: true,
          seconds: 20
        })
      },
      updateDto: function(returnDto) {
        this.returnDraftDto.Items                    = returnDto.Items
        this.returnDraftDto.McfReturnAmountRemaining = returnDto.McfReturnAmountRemaining
        this.returnDraftDto.RpReturnAmountRemaining  = returnDto.RpReturnAmountRemaining
        this.returnDraftDto.SubtotalMcf              = returnDto.SubtotalMcf
        this.returnDraftDto.SubtotalRapidparts       = returnDto.SubtotalRapidparts
        this.returnDraftDto.MinimumReturnAmount      = returnDto.MinimumReturnAmount
        this.returnDraftDto.MinimumItemAmount        = returnDto.MinimumItemAmount
        this.returnDraftDto.Errors                   = returnDto.Errors 
      },
      calculateTotals: function() {
        let total = 0;
        if (!(this.returnDraftDto === undefined || this.returnDraftDto.Items === undefined))
        {
          for (let i = 0; i < this.returnDraftDto.Items.length; i++) {
            this.returnDraftDto.Items[i].Total = this.returnDraftDto.Items[i].Price * this.returnDraftDto.Items[i].Quantity;
            total += this.returnDraftDto.Items[i].Total;
          }
        }

        this.total = total;

        this.availableTotal = this.returnDraftDto.McfReturnAmountRemaining + this.returnDraftDto.RpReturnAmountRemaining
      },
      DeleteFromReturn(event,id,arrayIndex) {
        event.target.disabled = true;
        event.target.innerHTML = "<em>...</em>";
        ReturnsService.DeleteItemFromReturn(this.activeAccountId, this.user.UserId, this.returnDraftDto.Id, id).then( () => {
          this.returnDraftDto.Items.splice(arrayIndex,1)
          this.calculateTotals()
        }).catch( () => {
          this.$store.commit("pushTimedMessage", {
            header: "Error occurred removing item from return.",
            IsError: true,
            seconds: 5
          });
          event.target.disabled = true;
          event.target.innerHTML = "<i class=\"icon-trash\"></i>";
        });
      }
    },


    computed: {
      ...mapGetters(["activeAccountId", "user", "getContentItem"])
    },
}
